import React from "react";
import { Colors } from "../../Constants/colors";
import schoolLogo from "../../images/school-color-logo.png";
import { FontFamily } from "../../Constants/Enums/FontFamily.enums";

const SideMenuHeader = () => {
  // const sideMenuBar = useSelector((state: RootState) => ({
  //   hideSideMenuBar: state.sideMenu.hideSideMenuBar,
  // }));

  // const dispatch = useDispatch();

  return (
    <div
      className="h-16 w-full flex flex-row items-center px-4 py-9"
      style={{ backgroundColor: Colors.TangerineOrange }}
    >
      <div className="school-logo-wrapper">
        <div className="school-logo">
          <img src={schoolLogo} alt="school logo" className="logo" />
        </div>
      </div>
      <div
        className="ml-1 text-xl school-name w-full px-2 font-semibold leading-5"
        style={{
          fontFamily: FontFamily.POPPINS_BOLD,
        }}
      >
        Rose Mount <br />
        <span className="text-sm font-medium">Pre School</span>
      </div>
      {/* <div
        className="hamburger-icon"
        onClick={() => {
          dispatch(setShowSideMenuBar(!sideMenuBar.hideSideMenuBar));
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="30"
          height="30"
          viewBox="0 0 50 50"
        >
          <path
            d="M 5 8 A 2.0002 2.0002 0 1 0 5 12 L 45 12 A 2.0002 2.0002 0 1 0 45 8 L 5 8 z M 5 23 A 2.0002 2.0002 0 1 0 5 27 L 45 27 A 2.0002 2.0002 0 1 0 45 23 L 5 23 z M 5 38 A 2.0002 2.0002 0 1 0 5 42 L 45 42 A 2.0002 2.0002 0 1 0 45 38 L 5 38 z"
            fill="white"
          ></path>
        </svg>
      </div> */}
    </div>
  );
};
export default SideMenuHeader;
